import React from "react";

export default function PdfKPIMetricBlock(props) {
  const goodOrBadText = props.negative ? "text-danger" : "text-success";
  const goodOrBadBg = props.negative ? "bg-danger" : "bg-success";
  return (
    <div className=" d-inline-block off-color-bg" style={{ margin: "3px", width: "185px", fontSize: "15px" }}>
      <p style={{ color: "#495057", margin: "10px" }}>{props.metricName} (Y/Y)</p>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {" "}
        <div className={`mb-1  metric-block-number mr-2 ${goodOrBadText}`}>{props.metric}</div>
        <div className={`mb-3 p-1  metric-block-yy-monthly ${goodOrBadBg}`}>{props.yy}</div>
      </div>
    </div>
  );
}
